import { LoadScript } from '@react-google-maps/api';

class LoadScriptOnlyIfNeeded extends LoadScript {
  componentDidMount() {
    const isAlreadyLoaded = window.google && window.google.maps && document.querySelector('body.first-hit-completed');
    if (!isAlreadyLoaded) {
      this.isCleaningUp().then(this.injectScript);
    }
    if (isAlreadyLoaded) {
      this.setState({ loaded: true });
    }
  }
}

export default LoadScriptOnlyIfNeeded;